import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { usePlatform } from "@platform//PlatformContext";
import { useOnboarding } from "../OnboardingContext";

export function useRedirectWhenNoInvitation(path: string = "/") {
  const { isHydrated } = usePlatform();

  const { invitation } = useOnboarding();

  const navigate = useNavigate();

  const hasAttemptedRedirect = useRef(false);

  useEffect(() => {
    // Wait until the platform is hydrated with local storage
    if (!isHydrated) return;

    // Wait until the invitation value is definitely resolved (null or real object)
    const isResolved = invitation !== undefined;

    if (isResolved && !invitation && !hasAttemptedRedirect.current) {
      hasAttemptedRedirect.current = true;
      navigate(path);
    }
  }, [invitation, isHydrated, navigate, path]);
}

export default useRedirectWhenNoInvitation;
